<template>
  <div class="fade-in">
    <h1 class="title">Your Profile</h1>

    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      class="account-form"
    >
      <formly-form :form="form" :model="model" :fields="fields"></formly-form>
      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Update
          </button>
        </div>
      </div>
    </form>

    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import PracticesService from "@/services/PracticesService";
import fields from "@/components/user/fields";

export default {
  name: "user-profile",

  mixins: [fields],

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      model: {
        id: null
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      PracticesService.updateProfile(this.model)
        .then(() => {
          this.loading = false;
          this.$refs.toastr.s("Your profile has been updated.");
        })
        .catch(errors => {
          this.loading = false;
          let errMsg = "There was an error updating your profile.";
          if (errors.response.status != 403) {
            this.setErrors(errors);
          } else {
            errMsg =
              "You must provide your current password to change your password.";
          }
          this.$refs.toastr.e(errMsg);
        });
    }
  },

  mounted() {
    const user = this.$store.state.user;
    const practice = this.$store.getters["practice/current"];
    this.model = {
      ...this.model,
      ...user,
      id: user.id,
      practiceId: practice.id
    };
  }
};
</script>

<style lang="scss"></style>
